import { GridSortItem } from "@mui/x-data-grid";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { useEncounterCreationGate } from "../../hooks/use-encounter-creation-gate";
import { PatientAllergyControllerApi } from "../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  useBaseContent,
} from "../../utils/utils";

interface Props {
  patientUuid?: string;
  pagination: DGT_Pagination;
  gridSorting?: GridSortItem[];
  sortBy?: string;
  sortDirection?: string;
  status?: boolean;
  archive?: boolean;
  searchString?: string;
  xTENANTID?: string | undefined;
  appointmentId?: any;
  providerStatus?: any;
  enabled?: boolean;
}

export type OptionData = {
  name: string;
  uuid: string;
};

/**
 *
 * @author Rajkumar Rathod
 */
export const usePatientAllergyList = ({
  patientUuid,
  pagination,
  gridSorting,
  status,
  archive,
  searchString,
  xTENANTID,
  appointmentId,
  providerStatus,
  enabled = true,
}: Props): useBaseContent<OptionData> => {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: searchString,
    prevPage,
  });
  const pageSize = getPageSize(searchString, pagination);

  const sortData = gridSorting?.[0];
  const skip = useEncounterCreationGate();

  return useQuery({
    queryKey: [
      "patient-allergy-list",
      patientUuid,
      pageIndex,
      pageSize,
      gridSorting,
      status,
      archive,
      searchString,
      appointmentId,
      providerStatus,
      xTENANTID,
      sortData,
    ],
    refetchOnWindowFocus: false,

    placeholderData: keepPreviousData,
    enabled: enabled && !skip,
    queryFn: async () =>
      await new PatientAllergyControllerApi(getConfigObject())
        .getPatientAllergy(
          pageIndex, //page
          pageSize, //size
          sortData?.field,
          sortData?.sort ?? undefined, // sortDirection
          patientUuid,
          appointmentId,
          status,
          archive,
          providerStatus,
          searchString,
          xTENANTID // xTENANTID
        )
        .then((res) => res?.data),
  });
};
